import { createContext, useCallback, useContext, useEffect, useRef, type ReactNode } from "react";

// A box whose open program preview takes the full row (#358, Antenore 19/10):
// the Library's grid cell, Home's hero. The preview says it is open while it
// is mounted; the box hears whether any preview inside it is, and widens.
// Only a layout signal: the preview keeps its own state where it is.
type Report = (delta: 1 | -1) => void;
const Ctx = createContext<Report | null>(null);

export function PreviewSpanScope({ onSpan, children }: { onSpan: (open: boolean) => void; children: ReactNode }) {
  const open = useRef(0);
  const onSpanRef = useRef(onSpan);
  onSpanRef.current = onSpan;
  const report = useCallback<Report>((delta) => {
    open.current += delta;
    onSpanRef.current(open.current > 0);
  }, []);
  return <Ctx.Provider value={report}>{children}</Ctx.Provider>;
}

/** The preview's side: open while mounted. Outside a scope, nothing. */
export function useSpanWhileOpen() {
  const report = useContext(Ctx);
  useEffect(() => {
    if (!report) return;
    report(1);
    return () => report(-1);
  }, [report]);
}
